import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common';

class MagstimTableMedications extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		return {
			columns: [
				{ title: CurrentLang().edit_patient_medication_label, property: 'Name' },
				{ title: CurrentLang().edit_patient_dosage_label, property: 'Dosage' },
				{ title: CurrentLang().edit_patient_unit_label, property: 'Units'},
				{ title: CurrentLang().edit_patient_frequency_label, property: 'Frequency'},
				{ title: CurrentLang().edit_patient_effective_date_label, property: 'EffectiveDate', formatter: this.formatUtcDate },
			],
			data: data
		};
    }
    
    resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Type', '');
	}
}




export default MagstimTableMedications;